module.exports = __webpack_public_path__ + "img/ep7-9.bdd4ea24.png";